module.exports = __webpack_public_path__ + "media/演唱-意外.759955c9.mp4";